import styled from '@emotion/styled';

import { IconButton } from '../../buttons/IconButton';

import { useIsRTL } from '../../../hooks/useIsRTL';
import { useCapabilityValue } from '../../../store/devices/useCapabilityValue';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

export function MediaControls(props) {
  const isRTL = useIsRTL();
  const [speakerShuffleValue, setSpeakerShuffleValue] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: 'speaker_shuffle',
  });
  const [, setSpeakerPrevValue] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: 'speaker_prev',
  });
  const [speakerPlayingValue, setSpeakerPlayingValue] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: 'speaker_playing',
  });
  const [, setSpeakerNextValue] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: 'speaker_next',
  });
  const [speakerRepeatValue, setSpeakerRepeatValue, speakerRepeatCapabilityObj] =
    useCapabilityValue({
      deviceId: props.deviceId,
      capabilityId: 'speaker_repeat',
    });

  return (
    <MediaControlsContainer>
      {props.component.capabilities.includes('speaker_shuffle') && (
        <IconButton
          size="24px"
          color={speakerShuffleValue ? 'rgba(18, 193, 255, 1)' : theme.color.white}
          url={glyph.capability.speakerShuffle}
          onPress={() => {
            setSpeakerShuffleValue(!speakerShuffleValue)
              .then(() => {})
              .catch(() => {});
          }}
        />
      )}

      {props.component.capabilities.includes('speaker_prev') && (
        <IconButton
          size="24px"
          color={theme.color.white}
          url={isRTL ? glyph.capability.speakerNext : glyph.capability.speakerPrev}
          onPress={() => {
            setSpeakerPrevValue(true)
              .then(() => {})
              .catch((error) => {});
          }}
        />
      )}

      {props.component.capabilities.includes('speaker_playing') && (
        <IconButton
          size="56px"
          color={theme.color.white}
          url={speakerPlayingValue ? glyph.core.pause : glyph.core.play}
          onPress={() => {
            setSpeakerPlayingValue(!speakerPlayingValue)
              .then(() => {})
              .catch(() => {});
          }}
        />
      )}

      {props.component.capabilities.includes('speaker_next') && (
        <IconButton
          size="24px"
          color={theme.color.white}
          url={isRTL ? glyph.capability.speakerPrev : glyph.capability.speakerNext}
          onPress={() => {
            setSpeakerNextValue(true)
              .then(() => {})
              .catch((error) => {});
          }}
        />
      )}

      {props.component.capabilities.includes('speaker_repeat') && (
        <IconButton
          size="24px"
          url={
            {
              none: glyph.capability.speakerRepeat,
              track: glyph.capability.speakerRepeat,
              playlist: glyph.capability.speakerRepeatList,
            }[speakerRepeatValue] ?? glyph.capability.speakerRepeat
          }
          color={
            speakerRepeatValue !== 'none' && speakerRepeatValue !== null
              ? 'rgba(18, 193, 255, 1)'
              : theme.color.white
          }
          onPress={() => {
            const values = speakerRepeatCapabilityObj.values;
            const currentIndex = values.findIndex((value) => value.id === speakerRepeatValue);
            const nextValue = values[(currentIndex + 1) % values.length].id;

            setSpeakerRepeatValue(nextValue)
              .then(() => {})
              .catch((error) => {});
          }}
        />
      )}
    </MediaControlsContainer>
  );
}

const MediaControlsContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: ${su(2)};
  margin-top: 42px;
`;
